import z from 'zod';

export const CHAT_BASE_PATH = `/chat` as const;
export type ChatBasePath = typeof CHAT_BASE_PATH;
export const ChatBasePathSchema = z.literal(CHAT_BASE_PATH);

export const isChatPath = (pathname: string): boolean => pathname === CHAT_BASE_PATH || pathname.startsWith(`${CHAT_BASE_PATH}/`);
